import React from 'react';
import logo from '../assets/images/logo.png';

export default () => (
  <div className="header">
    <img src={logo} className="logo" alt="logo" width="100%" />
  </div>
);
